export const initialCountryCodesStore = {
  data: {
    countryCodes: [],
  },
};
